
import Vue from "vue";
import app from "./app";
import xss from "@kkmh/xss";
 
Vue.directive("xss", function(el, binding) {
    el.innerHTML = xss(binding.value);
});

Vue.config.productionTip = false;

new Vue({
    el: "#app",
    components: { app },
    template: "<app/>",
});


// WEBPACK FOOTER //
// ./src/pages/normal/protocol/index.js